export const projekte = [
  {
    id: 'aufstockung-privathaus-meran-2026',
    title: 'Aufstockung Privathaus Meran',
    ort: 'Meran, Südtirol',
    kategorie: 'Aufstockung',
    jahr: '2026',
    image: '/assets/fotos/hb-foto-6.jpeg',
    images: ['/assets/fotos/hb-foto-6.jpeg', '/assets/fotos/hb-foto-7.jpeg', '/assets/fotos/hb-foto-8.jpeg'],
    kurztext: 'Aufstockung eines Bestandsgebäudes um ein vollständiges Obergeschoss in Holzrahmenbauweise – KlimaHaus A, fertiggestellt in einer Saison.',
    herausforderung: 'Das Bestandsgebäude durfte während der gesamten Bauphase bewohnt bleiben. Die neue Geschossdecke musste statisch präzise in das bestehende Mauerwerk integriert werden.',
    loesung: 'Vollständige Vorfertigung aller Wandelemente und Deckenträger im Werk. Montage in nur 4 Tagen – minimale Belästigung für die Bewohner, maximale Präzision.',
    ergebnis: 'Neues Wohngeschoss mit 98 m² Nutzfläche. KlimaHaus A zertifiziert. Bezugsfertig innerhalb von 14 Wochen nach Baubeginn.',
    leistungen: ['Aufstockung', 'Holzrahmenbau', 'Deckenträger', 'Fassade', 'Dachausbau'],
    tags: ['Aufstockung'],
    it: {
      title: 'Sopraelevazione Casa Privata Merano',
      kurztext: 'Sopraelevazione di un edificio esistente con un piano superiore completo in costruzione a telaio in legno – KlimaHaus A, completato in una stagione.',
      herausforderung: 'L\'edificio esistente doveva rimanere abitato durante l\'intera fase di costruzione. Il nuovo solaio doveva essere integrato staticamente con precisione nella muratura esistente.',
      loesung: 'Prefabbricazione completa di tutti gli elementi parete e travi del solaio in officina. Montaggio in soli 4 giorni – minimo disturbo per i residenti, massima precisione.',
      ergebnis: 'Nuovo piano abitativo con 98 m² di superficie utile. Certificato KlimaHaus A. Pronto all\'uso entro 14 settimane dall\'inizio dei lavori.',
      leistungen: ['Sopraelevazione', 'Sistema a telaio in legno', 'Travi del solaio', 'Facciata', 'Ampliamento del tetto']
    }
  },
  {
    id: 'holzhaus-neubau-naturns-2026',
    title: 'Holzhaus Naturns',
    ort: 'Naturns, Südtirol',
    kategorie: 'Holzhaus',
    jahr: '2026',
    image: '/assets/fotos/hb-foto-3.jpeg',
    images: ['/assets/fotos/hb-foto-3.jpeg', '/assets/fotos/hb-foto-9.jpeg', '/assets/fotos/hb-foto-4.jpeg'],
    kurztext: 'Neubau eines zweigeschossigen Einfamilienhauses in Holzrahmenbauweise in Naturns – schlüsselfertig, KlimaHaus A.',
    herausforderung: 'Planung und Ausführung eines kompakten Einfamilienhauses auf einem Hanggrundstück mit komplexen Anforderungen an Statik und Energieeffizienz.',
    loesung: 'Holzrahmenbaukonstruktion mit hochdämmenden Wandaufbauten (U-Wert 0,12 W/m²K). Vorfertigung aller Wand- und Dachelemente im Werk – Rohbauphase in 5 Tagen.',
    ergebnis: 'Schlüsselfertiges Einfamilienhaus mit 165 m² Wohnfläche, KlimaHaus A, Photovoltaik-bereit. Übergabe 12 Wochen nach Montagestart.',
    leistungen: ['Holzrahmenbau', 'Dachstuhl', 'Fassade in Lärchenholz', 'Fenstereinbau', 'Innenausbau'],
    tags: ['Holzhaus'],
    it: {
      title: 'Casa in Legno Naturno',
      kurztext: 'Nuova costruzione di una casa unifamiliare a due piani in costruzione a telaio in legno a Naturno – chiavi in mano, KlimaHaus A.',
      herausforderung: 'Progettazione e realizzazione di una casa unifamiliare compatta su un terreno in pendenza con requisiti complessi per la statica e l\'efficienza energetica.',
      loesung: 'Costruzione a telaio in legno con pareti ad alto isolamento termico (valore U 0,12 W/m²K). Prefabbricazione di tutti gli elementi di parete e tetto in officina – fase di struttura in 5 giorni.',
      ergebnis: 'Casa unifamiliare chiavi in mano con 165 m² di superficie abitativa, KlimaHaus A, predisposta per il fotovoltaico. Consegna 12 settimane dopo l\'inizio del montaggio.',
      leistungen: ['Sistema a telaio in legno', 'Struttura del tetto', 'Facciata in larice', 'Posa finestre', 'Rifinitura interna']
    }
  },
  {
    id: 'hotel-dachausbau-algund-2026',
    title: 'Hotel Dachausbau Algund',
    ort: 'Algund, Südtirol',
    kategorie: 'Hotelbau',
    jahr: '2026',
    image: '/assets/fotos/hb-foto-10.jpeg',
    images: ['/assets/fotos/hb-foto-10.jpeg', '/assets/fotos/hb-foto-11.jpeg', '/assets/fotos/hb-foto-1.jpeg'],
    kurztext: 'Dachausbau und Erweiterung einer Hotelanlage in Algund um drei neue Superior-Suiten in Holzbauweise – realisiert in der Zwischensaison.',
    herausforderung: 'Die Erweiterung musste ausschließlich in der Zwischensaison (Oktober–April) realisiert werden – bei laufendem Betrieb im Erdgeschoss und unter Einhaltung strenger Lärmschutzauflagen.',
    loesung: 'Vorfertigung aller Holzelemente im Werk, Montage in zwei Wochen. Trockenbau und Ausbau mit hochwertigen Materialien, abgestimmt auf das Hoteldesign.',
    ergebnis: 'Drei neue Superior-Suiten mit je 38 m² – in der Sommersaison 2026 bereits ausgebucht. Rückamortisation in weniger als 3 Saisonen kalkuliert.',
    leistungen: ['Dachausbau', 'Holzrahmenbau', 'Sanitär-Vorinstallation', 'Holzfassade', 'Innenausbau'],
    tags: ['Hotelbau', 'Aufstockung'],
    it: {
      title: 'Ampliamento Mansarda Hotel Lagundo',
      kurztext: 'Ampliamento del tetto e dell\'hotel a Lagundo con tre nuove suite superiori in costruzione in legno – realizzato nella bassa stagione.',
      herausforderung: 'L\'ampliamento doveva essere realizzato esclusivamente nella bassa stagione (ottobre–aprile) – con l\'attività al piano terra in corso e nel rispetto di severe norme antirumore.',
      loesung: 'Prefabbricazione di tutti gli elementi in legno in officina, montaggio in due settimane. Costruzione a secco e rifinitura con materiali pregiati, coordinati con il design dell\'hotel.',
      ergebnis: 'Tre nuove suite superiori da 38 m² ciascuna – già completamente prenotate per la stagione estiva 2026. Ammortamento calcolato in meno di 3 stagioni.',
      leistungen: ['Ampliamento del tetto', 'Sistema a telaio in legno', 'Preinstallazione impianti', 'Facciata in legno', 'Rifinitura interna']
    }
  },
  {
    id: 'camping-sonnenberg-partschins',
    title: 'Camping am Sonnenberg',
    ort: 'Partschins, Südtirol',
    kategorie: 'Hotelbau',
    jahr: '2025',
    image: 'https://hafner-ec.com/wp-content/uploads/2025/08/Hafner-Bauunternehmen-Baufirma-Meran-Camping-Partschins-18-DSCF1377-2000.jpg',
    images: [
      'https://hafner-ec.com/wp-content/uploads/2025/08/Hafner-Bauunternehmen-Baufirma-Meran-Camping-Partschins-18-DSCF1377-2000.jpg',
      'https://hafner-ec.com/wp-content/uploads/2025/02/Camping-Meran-Baufirma-Hafner-Schluesselfertig-1.jpg',
      '/assets/fotos/hb-foto-k5.jpeg',
      '/assets/fotos/hb-foto-k1.jpeg'
    ],
    kurztext: 'Hochwertiger Camping-Holzbau mit Lodges und Gemeinschaftsbauten im Naturpark.',
    herausforderung: 'Realisierung hochwertiger Unterkünfte und Gemeinschaftsgebäude in sensibler Naturschutzlage – mit kürzester Bauzeit und maximaler Schonung des Geländes.',
    loesung: 'Konsequenter Einsatz von Holzmodulen und vorgefertigten Elementen. Alle Bauteile wurden im Werk fertiggestellt und auf der Baustelle montiert – minimaler Eingriff, maximale Qualität.',
    ergebnis: 'Fertigstellung innerhalb einer Saison. Hochwertige Atmosphäre, die dem natürlichen Umfeld gerecht wird.',
    leistungen: ['Tragwerk', 'Fassade', 'Dachstuhl', 'Innenausbau in Holz'],
    tags: ['Hotelbau', 'Aufstockung'],
    it: {
      title: 'Camping am Sonnenberg',
      kurztext: 'Costruzione in legno di pregio per un campeggio con lodges e edifici comuni nel parco naturale.',
      herausforderung: 'Realizzazione di alloggi di pregio e edifici comuni in un\'area naturale protetta – con i più brevi tempi di costruzione e il massimo rispetto del terreno.',
      loesung: 'Uso sistematico di moduli in legno ed elementi prefabbricati. Tutti i componenti sono stati completati in officina e montati in cantiere – intervento minimo, qualità massima.',
      ergebnis: 'Completamento nell\'arco di una stagione. Atmosfera di pregio in armonia con l\'ambiente naturale.',
      leistungen: ['Struttura portante', 'Facciata', 'Struttura del tetto', 'Rifinitura interna in legno']
    }
  },
  {
    id: 'kohlbrenner-lodges-moelten',
    title: 'Kohlbrenner Lodges',
    ort: 'Mölten, Südtirol',
    kategorie: 'Hotelbau',
    jahr: '2024',
    image: '/assets/fotos/hb-foto-k3.jpeg',
    images: [
      '/assets/fotos/hb-foto-k3.jpeg',
      '/assets/fotos/hb-foto-k4.jpeg',
      '/assets/fotos/hb-foto-k5.jpeg',
      '/assets/fotos/hb-foto-k2.jpeg',
      '/assets/fotos/hb-foto-k1.jpeg',
      'https://hafner-ec.com/wp-content/uploads/2025/04/Kohlbrenner-99-2500.jpg',
    ],
    kurztext: 'Exklusive Holz-Lodges in alpiner Lage – präzise Planung und schnelle Ausführung.',
    herausforderung: 'Exklusiver Lodgebau in exponierter Höhenlage mit komplexen Anforderungen an Wärmeschutz, Witterungsbeständigkeit und Ästhetik.',
    loesung: 'Massive Holzkonstruktionen mit optimaler Dämmung, hochwertigen Holzfassaden und individuell gestalteten Innenräumen.',
    ergebnis: 'Einzigartige Ferienanlage, die Premium-Urlauber anzieht und in der Region für Aufsehen sorgt.',
    leistungen: ['Holzkonstruktion', 'Holzfassaden', 'Dachkonstruktion', 'Terrassen'],
    tags: ['Hotelbau', 'Holzfassaden', 'Dachstuhl'],
    it: {
      title: 'Kohlbrenner Lodges',
      kurztext: 'Lodges in legno esclusive in posizione alpina – pianificazione precisa e realizzazione rapida.',
      herausforderung: 'Costruzione di lodges esclusive in quota esposta con requisiti complessi di protezione termica, resistenza agli agenti atmosferici ed estetica.',
      loesung: 'Costruzioni massive in legno con isolamento ottimale, facciate in legno di pregio e interni progettati individualmente.',
      ergebnis: 'Un resort vacanze unico che attira ospiti premium e fa parlare di sé nella regione.',
      leistungen: ['Costruzione in legno', 'Facciate in legno', 'Struttura del tetto', 'Terrazze']
    }
  },
  {
    id: 'live-merano-camping',
    title: 'live merano camping',
    ort: 'Meran, Südtirol',
    kategorie: 'Hotelbau',
    jahr: '2025',
    image: 'https://hafner-ec.com/wp-content/uploads/2025/02/Camping-Meran-Baufirma-Hafner-Schluesselfertig-1.jpg',
    images: ['https://hafner-ec.com/wp-content/uploads/2025/02/Camping-Meran-Baufirma-Hafner-Schluesselfertig-1.jpg'],
    kurztext: 'Schlüsselfertiger Campingbau mit Holzelementen in modernem Design.',
    herausforderung: 'Realisierung moderner Campingunterkünfte mit Premium-Charakter und wirtschaftlichem Baubudget.',
    loesung: 'Standardisierte Holzmodule mit individueller Gestaltung – effizient in der Herstellung, hochwertig im Ergebnis.',
    ergebnis: 'Saisongerechte Fertigstellung, begeisterte Gäste.',
    leistungen: ['Modulbau', 'Holzfassaden', 'Dachkonstruktion'],
    tags: ['Hotelbau', 'Holzfassaden'],
    it: {
      title: 'live merano camping',
      kurztext: 'Costruzione di campeggio chiavi in mano con elementi in legno in design moderno.',
      herausforderung: 'Realizzazione di strutture ricettive per campeggio di carattere premium con budget edilizio economico.',
      loesung: 'Moduli in legno standardizzati con design individuale – efficienti nella produzione, di pregio nel risultato.',
      ergebnis: 'Completamento nei tempi stagionali, ospiti entusiasti.',
      leistungen: ['Edilizia modulare', 'Facciate in legno', 'Struttura del tetto']
    }
  },
  {
    id: 'dachstuhl-sanierung-meran',
    title: 'Industriehalle Siebenförcher',
    ort: 'Südtirol',
    kategorie: 'Gewerbe',
    jahr: '2024',
    image: '/assets/fotos/hb-foto-2-3.jpeg',
    images: ['/assets/fotos/hb-foto-2-3.jpeg', '/assets/fotos/hb-foto-3.jpeg'],
    kurztext: 'Neubau einer Industriehalle für das Unternehmen Siebenförcher – Holztragwerk, Fassade und Dachkonstruktion.',
    herausforderung: 'Errichtung einer großflächigen Industriehalle in Holzbauweise mit hohen Anforderungen an Tragsicherheit, Brandschutz und Fertigstellungstermin.',
    loesung: 'Holz-Leimtragwerk mit BSH-Bindern, vorgefertigte Wandelemente und präzise abgestimmter Montageplan für einen reibungslosen Bauablauf.',
    ergebnis: 'Fertigstellung im vorgesehenen Terminrahmen. Energieeffiziente und repräsentative Halle mit langlebiger Holzkonstruktion.',
    leistungen: ['Hallentragwerk', 'BSH-Binder', 'Holzfassade', 'Dachkonstruktion'],
    tags: ['Gewerbe'],
    it: {
      title: 'Capannone Industriale Siebenförcher',
      kurztext: 'Nuova costruzione di un capannone industriale per l\'azienda Siebenförcher – struttura portante in legno, facciata e struttura del tetto.',
      herausforderung: 'Realizzazione di un capannone industriale di grandi dimensioni in costruzione lignea con elevati requisiti di sicurezza strutturale, protezione antincendio e termine di completamento.',
      loesung: 'Struttura portante in legno lamellare con travi BSH, elementi parietali prefabbricati e piano di montaggio coordinato con precisione per un processo costruttivo senza intoppi.',
      ergebnis: 'Completamento nel termine previsto. Capannone energeticamente efficiente e rappresentativo con struttura in legno di lunga durata.',
      leistungen: ['Struttura portante', 'Travi BSH', 'Facciata in legno', 'Struttura del tetto']
    }
  },
  {
    id: 'holzfassade-weinstrasse',
    title: 'Hofstelle Tscherms',
    ort: 'Tscherms, Südtirol',
    kategorie: 'Sanierung',
    jahr: '2024',
    image: '/assets/fotos/hb-foto-8-1.jpeg',
    images: ['/assets/fotos/hb-foto-8-1.jpeg', '/assets/fotos/hb-foto-2-1.jpeg', '/assets/fotos/hb-foto-6.jpeg', '/assets/fotos/hb-foto-3-1.jpeg'],
    kurztext: 'Abbruch und Wiederaufbau einer historischen Hofstelle in Tscherms – Holzbau mit zeitgemäßer Architektur.',
    herausforderung: 'Die bestehende Hofstelle war baulich nicht sanierbar. Ziel war ein Neubau im Geiste des Bestands – ortstypisch, handwerklich hochwertig und energetisch auf dem neuesten Stand.',
    loesung: 'Vollständiger Abbruch und Wiederaufbau in Holzrahmenbauweise mit Lärchenholzfassade. Neues Volumen, das sich respektvoll in die Umgebung einfügt.',
    ergebnis: 'Authentisch wirkender Neubau mit modernem Energiestandard – Klimahaus A zertifiziert.',
    leistungen: ['Holzrahmenbau', 'Holzfassade', 'Dachstuhl', 'Terrassen'],
    tags: ['Sanierung', 'Holzfassaden', 'Holzhaus'],
    it: {
      title: 'Maso Tscherms',
      kurztext: 'Demolizione e ricostruzione di un maso storico a Tscherms – costruzione in legno con architettura contemporanea.',
      herausforderung: 'Il maso esistente non era risanabile dal punto di vista edilizio. L\'obiettivo era una nuova costruzione nello spirito del patrimonio esistente – tipica del luogo, artigianalmente di pregio e con i più recenti standard energetici.',
      loesung: 'Demolizione completa e ricostruzione in sistema a telaio in legno con facciata in legno di larice. Nuovo volume che si inserisce rispettosamente nel contesto.',
      ergebnis: 'Nuova costruzione dall\'aspetto autentico con moderni standard energetici – certificato KlimaHaus A.',
      leistungen: ['Sistema a telaio in legno', 'Facciata in legno', 'Struttura del tetto', 'Terrazze']
    }
  },
  {
    id: 'villa-am-hang-marling',
    title: 'Aufstockung Meran',
    ort: 'Meran, Südtirol',
    kategorie: 'Aufstockung',
    jahr: '2024',
    image: '/assets/fotos/hb-foto-1-1.jpeg',
    images: ['/assets/fotos/hb-foto-1-1.jpeg', '/assets/fotos/hb-foto-7.jpeg', '/assets/fotos/hb-foto-9.jpeg'],
    kurztext: 'Aufstockung eines Bestandsgebäudes in Meran mit neuem Vollgeschoss und hochwertiger Holzfassadenverkleidung.',
    herausforderung: 'Das Bestandsgebäude sollte um ein vollwertiges Wohngeschoss aufgestockt und gleichzeitig mit einer neuen Fassade optisch erneuert werden – alles in bewohntem Zustand.',
    loesung: 'Leichte Holzrahmenkonstruktion für die Aufstockung kombiniert mit einer hinterlüfteten Lärchenholzfassade über alle Geschosse. Kurze Montagezeit, minimale Beeinträchtigung.',
    ergebnis: 'Neues Wohngeschoss und vollständig erneuertes Erscheinungsbild in wenigen Wochen Bauzeit. Klimahaus-Standard erreicht.',
    leistungen: ['Aufstockung', 'Holzfassade', 'Dämmung', 'Dachkonstruktion'],
    tags: ['Aufstockung', 'Holzfassaden'],
    it: {
      title: 'Sopraelevazione Merano',
      kurztext: 'Sopraelevazione di un edificio esistente a Merano con un nuovo piano completo e rivestimento di facciata in legno di pregio.',
      herausforderung: 'L\'edificio esistente doveva essere sopraelevato di un piano abitativo completo e allo stesso tempo rinnovato visivamente con una nuova facciata – tutto in stato di abitazione.',
      loesung: 'Leggera costruzione a telaio in legno per la sopraelevazione combinata con una facciata ventilata in legno di larice su tutti i piani. Breve tempo di montaggio, minimo disagio.',
      ergebnis: 'Nuovo piano abitativo e aspetto completamente rinnovato in poche settimane di costruzione. Raggiunto lo standard KlimaHaus.',
      leistungen: ['Sopraelevazione', 'Facciata in legno', 'Isolamento', 'Struttura del tetto']
    }
  },
  {
    id: 'seniorenwohnheim-naturns',
    title: 'Haus Haas – Montan',
    ort: 'Montan, Südtirol',
    kategorie: 'Aufstockung',
    jahr: '2023',
    image: 'https://hafner-ec.com/wp-content/uploads/2025/10/Haus-Haas-Wohnung-Montan-Amadeus-Hafner-%C2%A9ArminHuber_low-0328-1000.jpg',
    images: ['https://hafner-ec.com/wp-content/uploads/2025/10/Haus-Haas-Wohnung-Montan-Amadeus-Hafner-%C2%A9ArminHuber_low-0328-1000.jpg'],
    kurztext: 'Aufstockung und Erweiterung des Gebäudes Haus Haas in Montan in hochwertiger Holzbauweise.',
    herausforderung: 'Erweiterung des bestehenden Gebäudes in einer sensiblen dörflichen Lage – statische Integration der neuen Holzkonstruktion in den Bestand.',
    loesung: 'Holzrahmenbaukonstruktion mit vorgefertigten Wandelementen. Präzise Montage, minimaler Eingriff in die bestehende Bausubstanz.',
    ergebnis: 'Neue Wohnfläche mit hochwertiger Holzkonstruktion – handwerklich präzise, architektonisch stimmig.',
    leistungen: ['Aufstockung', 'Holzrahmenbau', 'Dachkonstruktion', 'Fassade'],
    tags: ['Aufstockung'],
    it: {
      title: 'Casa Haas – Montagna',
      kurztext: 'Sopraelevazione e ampliamento dell\'edificio Casa Haas a Montagna in costruzione lignea di pregio.',
      herausforderung: 'Ampliamento dell\'edificio esistente in una delicata posizione paesana – integrazione statica della nuova costruzione in legno nel patrimonio edilizio.',
      loesung: 'Costruzione a telaio in legno con elementi parietali prefabbricati. Montaggio preciso, intervento minimo nella struttura edilizia esistente.',
      ergebnis: 'Nuova superficie abitativa con costruzione in legno di pregio – artigianalmente precisa, architettonicamente armoniosa.',
      leistungen: ['Sopraelevazione', 'Sistema a telaio in legno', 'Struttura del tetto', 'Facciata']
    }
  },
  {
    id: 'gewerbehalle-lana',
    title: 'Wirtschaftsgebäude Mölten',
    ort: 'Mölten, Südtirol',
    kategorie: 'Gewerbe',
    jahr: '2023',
    image: '/assets/fotos/hb-foto-2.jpeg',
    images: ['/assets/fotos/hb-foto-2.jpeg', '/assets/fotos/hb-foto-12.jpeg'],
    kurztext: 'Neubau eines landwirtschaftlichen Stalls und Wirtschaftsgebäudes in Mölten – solide Holzkonstruktion, sauber ausgeführt.',
    herausforderung: 'Errichtung eines dauerhaften landwirtschaftlichen Wirtschaftsgebäudes unter anspruchsvollen Bedingungen in Hanglage und mit strikten Fristen vor der Saison.',
    loesung: 'Holz-Leimtragwerk mit großzügigen Öffnungen für Belichtung und Belüftung. Vorfertigung aller Elemente für kurze Montagezeit auf der Baustelle.',
    ergebnis: 'Fertiggestellt vor Saisonbeginn. Robuste, langlebige Konstruktion – handwerklich sauber ausgeführt.',
    leistungen: ['Hallentragwerk', 'BSH-Binder', 'Holzfassade', 'Dacheindeckung'],
    tags: ['Gewerbe'],
    it: {
      title: 'Edificio Rurale Mölten',
      kurztext: 'Nuova costruzione di una stalla e di un edificio rurale a Mölten – solida costruzione in legno, realizzata con cura.',
      herausforderung: 'Realizzazione di un edificio rurale duraturo in condizioni impegnative su terreno in pendenza e con scadenze stringenti prima della stagione.',
      loesung: 'Struttura portante in legno lamellare con ampie aperture per illuminazione e ventilazione. Prefabbricazione di tutti gli elementi per brevi tempi di montaggio in cantiere.',
      ergebnis: 'Completato prima dell\'inizio della stagione. Costruzione robusta e duratura – realizzata con cura artigianale.',
      leistungen: ['Struttura portante', 'Travi BSH', 'Facciata in legno', 'Copertura del tetto']
    }
  },
];

export const getProjektById = (id) => projekte.find(p => p.id === id);

export const kategorien = ['Alle', 'Aufstockung', 'Dachstuhl', 'Holzhaus', 'Hotelbau', 'Sanierung', 'Holzfassaden', 'Gewerbe'];
